import '/src/sass/app.scss';

import $ from 'jquery'
import initSwiper from './swiper'
import initAlpine from './alpine'

$(function() {
    initAlpine()
    initSwiper()
})
